module.exports = __webpack_public_path__ + "img/download.0bcb1c7e.svg";